import rmlogo from '@wildscreen/ui-components/src/assets/svgs/rocketmakers.svg';
import * as React from 'react';

import styles from './rocketmakers.module.scss';

export const Rocketmakers: React.FC = () => {
  return (
    <a className={styles.rmLogo} target="__blank" href="https://www.rocketmakers.com">
      <img width={174} height={44} src={rmlogo} alt="" />
    </a>
  );
};
